var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeSlotEventCardAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#DC3545"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 6.5,
    stroke: "#DC3545",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 10.6423C16.375 8.91025 16.375 8.04424 16.1705 7.75289C15.966 7.46154 15.1517 7.18281 13.5232 6.62535L13.2129 6.51914C12.364 6.22855 11.9395 6.08325 11.5 6.08325C11.0605 6.08325 10.636 6.22855 9.78709 6.51914L9.47682 6.62535C7.84825 7.18281 7.03396 7.46154 6.82948 7.75289C6.625 8.04424 6.625 8.91025 6.625 10.6423C6.625 10.9039 6.625 11.1876 6.625 11.4953C6.625 14.5492 8.92112 16.0312 10.3617 16.6605C10.7525 16.8312 10.9479 16.9166 11.5 16.9166C12.0521 16.9166 12.2475 16.8312 12.6383 16.6605C14.0789 16.0312 16.375 14.5492 16.375 11.4953C16.375 11.1876 16.375 10.9039 16.375 10.6423Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.33325V11.4999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4993 13.6666C11.2002 13.6666 10.9577 13.4241 10.9577 13.1249C10.9577 12.8258 11.2002 12.5833 11.4993 12.5833C11.7985 12.5833 12.041 12.8258 12.041 13.1249C12.041 13.4241 11.7985 13.6666 11.4993 13.6666Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSlotEventCardAlert);
export default __webpack_public_path__ + "static/media/freeSlot-event-card-alert.cf986d721492ac29534a685a07951c3b.svg";
export { ForwardRef as ReactComponent };